export function getAbortControllerTimeout(ms: number) {
  if (typeof AbortController !== "undefined") {
    const abortController = new AbortController();
    setTimeout(() => abortController.abort(), ms);
    return abortController;
  }
  return null;
}
